import { useState } from 'react';
import { Card, CardBody, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import GenericFormCard from '../../../../components/moduleCommonFormik/GenericFormCard.component';
import Editor from '../../../../components/ContentEditor';
import { FieldArray, useFormikContext } from 'formik';
import { APPLICANT_DETAILS_MORTGAGE, MORTGAGE_CLOSURE_TAB, MORTGAGE_CURRENT_MORTGAGE_DETAILS, MORTGAGE_DECLARATION_LABEL, PLOT_DETAILS } from '../Mortgage.const';
import Declaration from '../../EstateManagement/Allotment/Declaration';
import { scrollToSection } from '../../../../utils/utils';

const MortgageClosureCorrespondence = ({ content, setContent, nextValidAction, isViewOnly, mortgageClosureResponse }: any) => {
    const [openSection, setOpenSection] = useState<string>('lesseeDetails');
    const { t } = useTranslation();

    const { values } = useFormikContext<any>();

    const onSectionChange = (currentSection: string) => {
        let previousSection = openSection;
        if (previousSection === currentSection) setOpenSection('');
        else setOpenSection(currentSection);

        scrollToSection([], false, MORTGAGE_CLOSURE_TAB, currentSection);
    };

    const renderLesseeDetails = () => {
        return (
            <div className='px-3'>
                {APPLICANT_DETAILS_MORTGAGE.map((val: any) => (
                    <GenericFormCard {...val} />
                ))}
            </div>
        );
    };

    const renderPlotDetails = () => {
        return (
            <div className='px-3'>
                {PLOT_DETAILS.map((val: any) => (
                    <GenericFormCard {...val} />
                ))}
            </div>
        );
    };

    const renderMortgageClosureDetails = () => {
        const mortgageCurrentMortgageDetails = MORTGAGE_CURRENT_MORTGAGE_DETAILS?.map((val: any) => ({
            ...val,
            formData: val?.formData?.filter((item: any) => item?.field !== 'mortgageOrderLetter')
        }));
        return (
            <>
                {values?.currentMortgageDetails?.length > 0 && (
                    <div className='px-3'>
                        <form>
                            <FieldArray name='currentMortgageDetails'>
                                {({ insert, remove, push }) => (
                                    <div>
                                        {values.currentMortgageDetails.map((data: any, index_p: number) => (
                                            <div className='row mt-3' key={index_p}>
                                                <div className='col-sm-12 align-items-center pb-2'>
                                                    <div className='formHeading'>{`Financial Institution/Bank - ${index_p + 1}`}</div>
                                                    <div className='ps-1'>
                                                        {mortgageCurrentMortgageDetails.map((val: any, _: number) => (
                                                            <GenericFormCard fieldPath={`currentMortgageDetails.${index_p}`} {...val} />
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </FieldArray>
                        </form>
                    </div>
                )}
            </>
        );
    };

    const renderNoteDetails = () => {
        return (
            <>
                <div>
                    <Form.Group>
                        <div className='col-lg-12 my-1 px-4 py-4'>
                            <Editor setContent={setContent} content={content} readOnly={isViewOnly ? isViewOnly : !nextValidAction?.isUpdatable} />
                        </div>
                    </Form.Group>
                </div>
            </>
        );
    };

    const renderDeclarationDetails = () => {
        return (
            <Declaration
                isChecked={[true, true, true]}
                hideCard={true}
                declarationList={MORTGAGE_DECLARATION_LABEL}
                handleCheckboxChange={() => {}}
                fileStoreId={mortgageClosureResponse?.signedConsolidatedDocRefId}
            ></Declaration>
        );
    };

    return (
        <>
            <Card className='checklist-outer mb-4 mx-3'>
                <CardBody>
                    <div className='row'>
                        {MORTGAGE_CLOSURE_TAB.map((val: any, index: number) => {
                            return (
                                <div className={`col-sm-12 collapsible_box noting-collapsible-box align-items-center py-3 px-0`}>
                                    <input type='checkbox' id={`${val.field}Form`} name={`${val.field}Form`} checked={openSection === val.field} onChange={() => onSectionChange(val.field)} />
                                    <label
                                        htmlFor={`${val.field}Form`}
                                        className='px-4 d-flex collapsible-box-label col-sm-12 checklist-heading noting-collapsible-box-label align-items-center justify-content-between'
                                    >
                                        {val.title}
                                    </label>
                                    {val.title === 'A - Lessee Details' && openSection === 'lesseeDetails' && renderLesseeDetails()}
                                    {val.title === 'B - Plot Details' && openSection === 'plotDetails' && renderPlotDetails()}
                                    {val.title === 'C - Mortgage Closure Details' && openSection === 'mortgageClosureDetails' && renderMortgageClosureDetails()}
                                    {val.title === 'D - Self Declaration' && openSection === 'selfDeclaration' && renderDeclarationDetails()}
                                    {val.title === 'E - Notes' && openSection === 'mortageClosureNotes' && renderNoteDetails()}
                                </div>
                            );
                        })}
                    </div>
                </CardBody>
            </Card>
        </>
    );
};
export default MortgageClosureCorrespondence;
